/** @format */
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import {
    ContentfulQueryVariables,
    getContentfulData,
} from '@toucan/client/core/contentful';
import { MarketContext } from '@toucan/client/global/market';
import { ContentfulQueryId } from '@toucan/common/contentful';

export const useContentful = <
    R,
    V extends ContentfulQueryVariables = undefined,
    SelectReturnType = undefined
>(
    queryId: ContentfulQueryId,
    variables?: V,
    options: UseQueryOptions<R, unknown, SelectReturnType> = {}
) => {
    const { activeMarket } = useContext(MarketContext);
    const locale = activeMarket.iso;

    return useQuery({
        queryKey: variables ? [queryId, variables] : [queryId],
        queryFn: () => getContentfulData<R>(queryId, locale, variables),
        ...options,
    });
};
